// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__fkAeo","title":"style__title__GtQAo","description":"style__description__4Dzf9","component":"style__component__ciEG-"};